import SuccessStoryEditContainer from './containers/SuccessStoryEditContainer'

export default SuccessStoryEditContainer
